import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import Slider from '../ui/Input/Slider/Slider'

import { sessionApi } from 'api/session'
import history from 'utils/appHistory'
import { updateSession } from 'utils/sqlite'

import BackIcon from 'assets/back-icon.png'
import GearIcon from 'assets/gear.png'
import SoundIcon from '../../assets/volume-2.svg'
import { setEndEvent, setVolume } from '../../store/actions/playerActions'

const PlayerTopButtons = ({
  playedTime,
  isPlayingFromPlaylist,
  toggleSettingsHandler,
  attachBackBtnRef,
  attachSettingsBtnRef,
  sessionId,
  isDoctor,
  setEndEvent,
  setVolume,
  sessionDb,
  sessionDbTable,
  sessionOnline,
  ...props
}) => {
  return (
    <Fragment>
      {/*  Treatment page, Player page top back button */}
      <button
        className="player_control_item drop_mod"
        ref={attachBackBtnRef}
        onClick={async () => {
          const goToPainRating = !isPlayingFromPlaylist && playedTime >= 60 && sessionId

          if (goToPainRating) {
            setEndEvent('clickAway')
            return history.push('/song-select')
          }

          if (sessionId) {
            const data = {
              playTime: playedTime,
              id: sessionId,
              endEvent: 'clickAway',
              sessionEnd: new Date(),
            }

            if (!window?.cordova || sessionOnline) {
              sessionApi
                .sendSessionInfoAfter(data)
                .then(
                  ({ error }) =>
                    error && console.log('Error updating session result: ', error)
                )
            } else {
              await updateSession(sessionDb, sessionDbTable, data)
            }
          }

          const redirect = isDoctor ? `/welcome-doctor` : '/song-select'

          history.replace(redirect)
        }}
      >
        <img className="controls_btn_icon" src={BackIcon} alt="player menu icon" />
      </button>
      <div className="control_volume">
        <div className="control_volume_icon">
          {/* <img className="controls_btn_icon" src={SoundIcon} alt="player menu icon" /> */}
          <SoundIcon className="controls_btn_icon" />
        </div>
        <div className="control_volume_slider">
          <Slider
            // {...props}
            initialValue={props.volume * 100}
            min={0}
            max={100}
            ariaLabelId={'ariaVolumeSlider'}
            onChange={(e) => setVolume(e.target.value / 100)}
            disabled={false}
          />
        </div>
      </div>
      <button
        ref={attachSettingsBtnRef}
        className="player_control_item menu_mod settings_mod"
        onClick={toggleSettingsHandler}
      >
        <img className="controls_btn_icon" src={GearIcon} alt="settings" />
      </button>
    </Fragment>
  )
}

const mapStateToProps = ({
  auth: { isDoctor },
  player: {
    sessionId,
    playedTime,
    allSongsMap,
    immersiveVideo,
    volume,
    playState,
    indicationType,
    songInfo,
    playingPlaylistSong,
    painLevelBefore,
    demoMode,
    sessionDb,
    sessionDbTable,
    sessionOnline,
  },
}) => ({
  isDoctor,
  sessionId,
  allSongsMap,
  immersiveVideo,
  volume,
  playState,
  indicationType,
  songInfo,
  playingPlaylistSong,
  painLevelBefore,
  demoMode,
  playedTime,
  sessionDb,
  sessionDbTable,
  sessionOnline,
})

const willMapDispatchToProps = { setEndEvent, setVolume }

export default connect(mapStateToProps, willMapDispatchToProps)(PlayerTopButtons)

PlayerTopButtons.propTypes = {
  isDoctor: PropTypes.bool.isRequired,
  sessionId: PropTypes.string,
  isPlayingFromPlaylist: PropTypes.bool.isRequired,
  toggleSettingsHandler: PropTypes.func.isRequired,
  attachBackBtnRef: PropTypes.func.isRequired,
  playedTime: PropTypes.number,
}
